import * as React from 'react';
import { formatPhone } from '@cian/frontend-e2e-deal-component';

import { trackCallMeBannerClick } from './tracking';
import { BannerLayout } from '../../components/BannerLayout/BannerLayout';
import { useApplicationContext } from '../../utils/applicationContext';
import { CONSULTATION_BLOCK } from '../../constants/images';
import { ConsultationRequestButtonContainer } from '../ConsultationRequestButtonContainer';
import { NBSP } from '../../constants/symbols';

import * as styles from '../../components/BannerLayout/styles.css';

export const CallMeBannerSection = () => {
  const { config } = useApplicationContext();

  const phone = config.getStrict<string>('e2e-deal-sale.customSupportContactPhone');

  return (
    <BannerLayout
      imageX1={CONSULTATION_BLOCK.x1}
      imageX2={CONSULTATION_BLOCK.x2}
      description={
        <>
          Ответим на вопросы в{NBSP}будни с{NBSP}07:00 до{NBSP}18:00 — звоните на{' '}
          <span className={styles['phone']}>{formatPhone({ phone })}</span>
        </>
      }
      action={
        <ConsultationRequestButtonContainer theme="fill_primary" onGetConsultationClick={trackCallMeBannerClick}>
          Хочу консультацию
        </ConsultationRequestButtonContainer>
      }
    />
  );
};
